import { DateFormatHelper } from '@/ui-kit/helpers/DateFormatHelper';
import { DEFAULT_TIME_FORMAT } from '@/ui-kit/components/form/controls/components/time-picker/constants';
import { createDate, formatDatetime } from '@/utils/date';
import { DEFAULT_VIEWING_DURATION_IN_MINUTES } from '../constants';
import { ListingBookViewingFormControlName } from '../form/enums';

export default class BookViewingPayloadMapper {
  static mapMlsPayload(bookViewing) {
    const appointment = this.#createMLSAppointment(
      bookViewing[ListingBookViewingFormControlName.Date],
      bookViewing[ListingBookViewingFormControlName.StartTime],
      bookViewing[ListingBookViewingFormControlName.Duration],
    );
    const additionalAppointment = bookViewing[ListingBookViewingFormControlName.AdditionalDate]
      && this.#createMLSAppointment(
        bookViewing[ListingBookViewingFormControlName.AdditionalDate],
        bookViewing[ListingBookViewingFormControlName.AdditionalStartTime],
        bookViewing[ListingBookViewingFormControlName.AdditionalDuration],
      );

    return {
      contactMethod: bookViewing[ListingBookViewingFormControlName.ContactMethod],
      phone: bookViewing[ListingBookViewingFormControlName.PhoneNumber],
      appointments: additionalAppointment ? [appointment, additionalAppointment] : [appointment],
    };
  }

  static mapBodePayload({ day, time }) {
    return {
      appointments: [this.#createBodeAppointment(day, time)],
    };
  }

  static #createBodeAppointment(day, time) {
    const startDate = createDate({ datetime: day })
      .hour(time.hour)
      .minute(time.minutes);

    return this.#createAppointment(startDate, DEFAULT_VIEWING_DURATION_IN_MINUTES);
  }

  static #createMLSAppointment(date, time, duration) {
    const dateString = formatDatetime({ datetime: date });
    const startDate = createDate({
      datetime: `${dateString} ${time}`, format: `YYYY-MM-DD ${DEFAULT_TIME_FORMAT}`,
    });

    return this.#createAppointment(startDate, duration);
  }

  static #createAppointment(startDate, duration) {
    return {
      startTime: startDate.toISOString(),
      endTime: startDate.add(duration, 'minute').toISOString(),
      timezone: DateFormatHelper.getTimezone(),
    };
  }
}
